import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

import { Configuration } from '../models/configuration.model';

const CONFIGURATION_FILE_URL = 'assets/configurations/env.json';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private bus$ = new ReplaySubject(1);

  initialized$ = this.bus$.asObservable();

  configuration: Configuration;

  constructor(private httpClient: HttpClient) { }

  loadConfiguration(): Promise<Configuration> {
    return this.httpClient.get<Configuration>(CONFIGURATION_FILE_URL).pipe(
      shareReplay(1),
      tap(assetsEnv => this.configuration = assetsEnv),
      tap(_ => this.bus$.next())
    ).toPromise();
  }
}
